import { BaseItem, NullablePartial } from './common';

export enum Group {
  Default = 'DEFAULT',
  OrganSystems = 'ORGAN_SYSTEMS',
  PrenatalFlowsheet = 'PRENATAL_FLOWSHEET', // obsolete
}

export enum Primitive {
  Boolean = 'BOOLEAN',
  Enum = 'ENUM',
  Float = 'FLOAT',
  Integer = 'INTEGER',
  MultiEnum = 'MULTI_ENUM',
  String = 'STRING',
}

export interface BaseStandardNoteField {
  parentId: string | null;
  standardNoteSectionId: string;
  referenceName: string;
  displayName: string | null;
  allowableDisplayNames: string[];
  rank: number;
  enabled: boolean;
  isDeleted: boolean;
  deletedTimestamp: Date | null;
  group: Group | null;
  primitive: Primitive;
  defaultValue: string;
  readOnly: boolean;
  options: string[] | null;
  min: number | null;
  max: number | null;
  interval: number | null;
  prefix: string | null;
  suffix: string | null;
}

export type CreateValues = NullablePartial<
  Omit<BaseStandardNoteField, 'rank' | 'isDeleted' | 'deletedTimestamp'>
>;

export type UpdateValues = Partial<
  Omit<BaseStandardNoteField, 'referenceName' | 'deletedTimestamp'>
>;

export interface StandardNoteField extends BaseItem, BaseStandardNoteField {}
export interface StandardNoteFieldWithOverride
  extends BaseItem,
    BaseStandardNoteField {
  defaultDisplayName: string | null;
  providerNoteFieldId: string | null;
}
